import React from 'react';
import {Divider, Modal, Steps} from "antd";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import uuidV4 from 'uuid/v4';
import GeneralInformation from "./GeneralInformation";
import CustomerInformation from "./CustomerInformation";
import {saveCallCenterMessageAppointment} from "../../actions/createAppointmentActions";
import VinInformation from "./VinInformation";
import {
  getComment,
  getCustomerInformation,
  getGeneralInformation,
  getVin
} from "../../selectors/createAppointmentRequest";
import {isLoading} from "../../selectors/appointmentCreationModal";
import {getSelectedDealerId} from "../../selectors/customerDealer";
import Constants from "../../services/Constants";
import './AppointmentCreationModal.css';
import MessageInformation from "./MessageInformation";

const {Step} = Steps;

class AppointmentMessageCreationModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      steps: [
        {step: 1, content: <VinInformation/>},
        {step: 2, content: <GeneralInformation mandatoryList={['mileage', 'model']}/>},
        {step: 6, content: <MessageInformation/>},
        {step: 5, content: <CustomerInformation mandatoryList={['lastname', 'phone', 'language']}/>}
      ]
    };
  }

  prevStep = () => {
    const {current} = this.state;
    this.setState({current: current - 1});
  };

  nextStep = () => {
    const {current} = this.state;
    this.setState({current: current + 1});
  }

  onSave = () => {
    const {
      vin,
      comment,
      customer,
      generalInformation,
      dealerId,
    } = this.props;
    this.props.dispatchSaveMessageAppointment({
      body: {
        ...generalInformation,
        ...customer,
        message: comment,
        uuid: uuidV4(),
      },
      params: {
        dealerId,
        vin
      }
    });
  }

  isNextIsDisabled = () => {
    const {current} = this.state;
    if (current === 0) {
      const {vin, dealerId} = this.props;
      return !vin || !vin.trim() === '' || vin.length !== 17 || !Constants.SUPPORTED_WMIS.includes(vin.slice(0, 3)) ||
        !dealerId;
    }
    if (current === 1) {
      const {generalInformation} = this.props;
      return !parseInt(generalInformation.mileage, 10) ||
        !generalInformation.model || generalInformation.model.trim() === '';
    }
    if (current === 2) {
      const {comment} = this.props;
      return !comment || !comment.trim() === '';
    }
    if (current === 3) {
      const {customer} = this.props;
      return !customer ||
        !customer.lastname || !customer.lastname.trim() === '' ||
        !customer.language || !customer.language.trim() === '' ||
        !customer.phone || !customer.phone.trim() === '';
    }
  }

  render() {
    const {visible, loading} = this.props;
    const {current, steps} = this.state;

    return (
      <Modal className="call-center" title={<FormattedMessage id="section.message-creation.modal.title"/>}
             visible={visible} onCancel={this.props.onModalClose} width='100rem' maskClosable={false}
             footer={[
               <div className={current > 0 ? "d-flex justify-content-between" : ""}>
                 {current > 0 && (
                   <button type="default" className="btn btn-o-primary" style={{width: 'inherit'}}
                           onClick={this.prevStep}>
                     <FormattedMessage id="customer.journey.nav.previous"/>
                   </button>
                 )}
                 {current < steps.length - 1 && (
                   <button disabled={loading || this.isNextIsDisabled()} type="default" className="btn btn-primary"
                           style={{width: 'inherit'}}
                           onClick={this.nextStep}>
                     <FormattedMessage id="customer.journey.nav.next"/>
                   </button>
                 )}
                 {current === steps.length - 1 && (
                   <button disabled={this.isNextIsDisabled()} type="default" className="btn btn-primary"
                           style={{width: 'inherit'}}
                           onClick={this.onSave}>
                     <FormattedMessage id="action.save"/>
                   </button>
                 )}
               </div>
             ]}>
        <Steps progressDot current={current}>
          {steps.map((item) => (
            <Step key={item.title}
                  title={<FormattedMessage id={`appointment_creation_modal.step_${item.step}`}/>}
            />
          ))}
        </Steps>
        <Divider/>
        <div className="steps-content">
          {steps[current].content}
        </div>
      </Modal>
    );
  }
}


const mapStateToProps = state => ({
  comment: getComment(state),
  dealerId: getSelectedDealerId(state),
  customer: getCustomerInformation(state),
  generalInformation: getGeneralInformation(state),
  loading: isLoading(state),
  vin: getVin(state),
});

const mapDispatchToProps = dispatch => ({
  dispatchSaveMessageAppointment: payload => dispatch(saveCallCenterMessageAppointment(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentMessageCreationModal);
